import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=5af62fea&scoped=true&"
import script from "./permissions.vue?vue&type=script&lang=js&"
export * from "./permissions.vue?vue&type=script&lang=js&"
import style0 from "./permissions.vue?vue&type=style&index=0&id=5af62fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af62fea",
  null
  
)

export default component.exports